export default __webpack_public_path__ + "static/media/team-mosaic-01.a3c19249.jpg";